import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWindsurfNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.13 1.74L9.48.5H7.66l-5.24 9.86 6.51 3.02-.6 1.12H2.24l-.53 1h11.76l.53-1H9.47l.66-1.24a12.24 12.24 0 000-11.52zM8.26 1.5h.62l.37.71c.219.417.41.848.574 1.29H7.2zm-1.59 3h3.483c.182.654.305 1.324.367 2H5.61zm-1.6 3h5.5c0 .67-.06 1.34-.18 2H4.01zm4.33 5l-4.31-2h5.07a11.573 11.573 0 01-.76 2z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWindsurfNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsWindsurfNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWindsurfNormalXsmall;
